import Http from 'Api/http';
import { BACKEND_URL_QUOTATION } from 'Config/routes';

/**
 * Consulta una cotización individual :)
 */
const selectInsuranceQuotations = (idQuotation, data) => new Promise((resolve, reject) => {
  new Http({
    full_url: `${BACKEND_URL_QUOTATION}${idQuotation}/select_insurance_quotations/`,
    method: 'PUT',
  }).fetch({
    data,
    success: resolve,
    error: reject,
  });
});

export default selectInsuranceQuotations;
